let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7XV6t")).then(() => parcelRequire('g48F1'));